export const useSwiftSearchHelper = () => {
  const { getInstance } = useInstantSearch()
  const instance = getInstance()

  const refinements = computed(() => {
    return instance.value.mainIndex.getResults()?.getRefinements()
  })

  const results = computed(() => {
    return instance.value.mainIndex.getResults()
  })

  const nbHits = computed(() => {
    return results.value?.nbHits ?? 1
  })

  const pages = computed(
    () => instance.value.mainIndex.getResults()?.nbPages ?? 0
  )

  const query = computed(() => {
    return results.value?.query
  })

  const countFilersNumericActivated = (
    objectFilters:
      | {
          ">=": any
          "<=": any
        }
      | {}
  ) => {
    if (isEmpty(objectFilters)) return 0

    let counter = 0
    // @ts-ignore
    counter += objectFilters[">="]?.length ?? 0
    // @ts-ignore
    counter += objectFilters["<="]?.length ?? 0

    return counter
  }

  const getFiltersNumbersByState = (facetName: string | string[]) => {
    let acc = 0

    const facetNames = Array.isArray(facetName) ? facetName : [facetName]
    const state = instance.value.mainIndex.getHelper()?.state

    facetNames.forEach((facetName) => {
      acc += state?.disjunctiveFacetsRefinements?.[facetName]?.length ?? 0
      if (state?.numericRefinements?.[facetName]) {
        acc += countFilersNumericActivated(
          state?.numericRefinements?.[facetName] ?? {}
        )
      }
    })

    return acc
  }

  const currentRefinements = computed(() => {
    return instance.value.mainIndex.getResults()
  })

  const totalActiveFilters = computed(() =>
    currentRefinements.value
      ? getFiltersNumbersByState([
          "inStock",
          "brand.name",
          "mainCategory.name",
          "deductibleProduct",
          "price.amount_float",
          "isDiscounted"
        ])
      : 0
  )

  return {
    nbHits,
    query,
    results,
    pages,
    getFiltersNumbersByState,
    currentRefinements,
    refinements,
    totalActiveFilters
  }
}
